import type { ReactElement } from 'react';
import { Check } from 'lucide-react';

import { UPGRADE_BENEFITS } from '../../constants/sales-copy';

export function BenefitsPanel(): ReactElement {
  return (
    <div>
      <h3 className="vtwo:text-lg vtwo:font-bold vtwo:mb-6">You're about to unlock:</h3>
      <div className="vtwo:flex vtwo:flex-col vtwo:gap-2">
        {UPGRADE_BENEFITS.map((benefit) => (
          <div key={benefit} className="vtwo:flex vtwo:items-center vtwo:gap-3">
            <Check className="vtwo:size-4 vtwo:text-green-600 vtwo:shrink-0" />
            <span className="vtwo:text-sm">{benefit}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
